import { useDispatch } from 'react-redux';

export default function useStoreToken() {
    const dispatch = useDispatch();

    const executor = (ansa_token) => {
        return dispatch({
            type: 'SET_TOKEN',
            payload: ansa_token,
        });
    };

    return executor;
};